<template>
  <div style="width: 1200px; margin: auto">
    <el-row class="buyid">
      <span>报价单号:</span>{{ code }}
      <span style="margin-left: 30px">招标单号:</span> {{ purchaseOrderCode }}
    </el-row>

    <div class="main">
      <div class="navs_top">
        <div>
          <h3 class="nav_top">{{ supplierInfo.name }}</h3>
          <div class="nav_content">
            <div class="renzhen">认证</div>
            <span
            ><i class="el-icon-phone">{{ supplierInfo.phone }}</i></span
            >
          </div>
        </div>
      </div>
      <div class="main_top"></div>
      <div class="nav_step">
        <div class="main-flag">
          <b></b>
          <span>报价信息</span>
        </div>
        <div class="bjinfo">
          <p><span>报价企业：</span>{{ supplierInfo.name }}</p>
          <p><span>招标对接联系方式：</span>{{ supplierInfo.phone }}</p>
          <p><span>报价备注：</span>{{ supplierInfo.remark }}</p>
          <p><span>招标对接人：</span>{{ supplierInfo.contactPerson }}</p>
          <p><span>报价总价：</span>{{ supplierInfo.quoteAmount }}</p>

          <p class="ament">
            <span>附件：</span>
            <el-link
              v-if="supplierInfo.attachment !== ''"
              :underline="false"
              type="primary"
              :href="supplierInfo.attachment"
              target="_blank"
            ><i class="el-icon-download"></i>
            </el-link>
            <span v-else>暂无附件</span>
          </p>
        </div>
        <div class="bjnum">
          <div>
            成交次数 <span>{{ supplierInfo.dealCount }}</span>
          </div>
          <div>
            报价次数<span>{{ supplierInfo.quoteCount }}</span>
          </div>
          <div>
            成交总金额<span>{{ supplierInfo.quoteAmount }}</span>
          </div>
        </div>
      </div>
      <!-- 报价产品 -->
      <div class="main_content">
        <template>
          <div class="main-flag">
            <b></b>
            <span>报价产品</span>
          </div>
          <el-table
            v-if="typedata==1"
            :header-cell-style="headClass"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column
              prop="purchaseOrderDetails.productName"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              prop="purchaseOrderDetails.deliverDays"
              label="发货时效(天)"
            >
            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.spec" label="规格型号">

            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.brand" label="品牌">
            </el-table-column>
            <el-table-column prop="accountPeriod" label="账期">
            </el-table-column>
            <el-table-column
              prop="purchaseOrderDetails.technicalRqmts"
              label="技术参数要求"
            >
            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.number" label="数量">
              <template slot-scope="scope">
                {{ scope.row.number == null ? 1 : scope.row.number }}
              </template>
            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.unit" label="单位">
            </el-table-column>
            <el-table-column
              prop="purchaseOrderDetails.priceLimit"
              label="单价(￥)"
            >
            </el-table-column>
            <el-table-column prop="amountTotal" label="小计"></el-table-column>
            <el-table-column prop="amount" label="报价价格"></el-table-column>
            <el-table-column prop="purchaseOrderDetails.remark" label="备注">
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  class="price"
                  @click="handleQuotedPrice(scope.row, scope.$index)"
                >
                  比价
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-if="typedata!=1"
            :header-cell-style="headClass"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="purchaseOrderDetails.projectName" label="项目名称">
            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.workDescs" label="工作描述"></el-table-column>
            <el-table-column prop="purchaseOrderDetails.calculateUnit" label="计量单位">
            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.quantities" label="工程量">

            </el-table-column>
            <el-table-column prop="purchaseOrderDetails.brandAndModel" label="品牌-型号">
            </el-table-column>
            <el-table-column prop="stuffPrice" label="设备材料单价">
            </el-table-column>
            <el-table-column prop="manMadePrice" label="人工单价">
            </el-table-column>
            <el-table-column prop="synthesizePrice" label="综合单价">
            </el-table-column>
            <el-table-column prop="amountTotal" label="小计"></el-table-column>
            <!--<el-table-column prop="amount" label="报价价格"></el-table-column>-->
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  class="price"
                  @click="handleQuotedPrice(scope.row, scope.$index)"
                >
                  比价
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <!-- 总价格对比柱状图 -->
      <div>
        <div class="main-flag">
          <b></b>
          <span>总价格对比</span>
        </div>
        <div id="TotalPrice" class="TotalPrice"></div>
      </div>
      <div class="zhongb" v-if="this.isSelected == 'null'">
        <el-button class="zbtn" @click="handleWinning()">中标</el-button>
      </div>
      <div class="zhongb" v-else></div>
    </div>
    <!--添加积分兑换弹框 -->
    <el-dialog
      v-dialogDrag
      title="报价产品价格对比"
      :visible.sync="editVisible"
      @open="open()"
    >
      <div id="priceComparison" class="PriceComparison"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false" class="zbtn">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as echarts from "echarts";

import {quoteDetails, purchaseOrderDetailsId, winning} from "@/api/xunyou";
import countDown from "@/components/countDown"; // 倒计时
import {mapState, mapMutations} from "vuex";

export default {
  data() {
    return {
      supplierInfo: {},
      loading: true,
      code: "",
      isSelected: "", //是否报价过
      purchaseOrderCode: "",
      accountStatus: JSON.parse(localStorage.getItem("userdata")).accountStatus,
      form: {
        quoteId: this.$route.query.quoteId,
        supplierId: this.$route.query.supplierId,
      },
      editVisible: false,
      info: "",
      area: "",
      tableData: [],
      PriceData: [],
      typedata: '',
      xData: [],
      deliver: [
        {name: "发布采购", context: "2021-12-09 14：25：22"},
        {name: "报价截至", context: "2021-12-09 14：25：22"},
        {name: "选择报价截至", context: "2021-12-09 14：25：22"},
        {name: "双方签订合同", context: "2021-12-09 14：25：22"},
      ],
    };
  },
  // 注册组件
  components: {
    countDown,
  },

  mounted() {
    this.handelData();

  },
  computed: {
    ...mapState(["getprovince"]),
  },
  created() {
    this.code = this.$route.query.code;
    this.purchaseOrderId = this.$route.query.purchaseOrderId;
    this.purchaseOrderCode = this.$route.query.purchaseOrderCode;
    this.isSelected = this.$route.query.isSelected;
    // console.log(this.$route.query.isSelected,"d");
  },
  methods: {
    //查询数据
    handelData() {
      this.loading = false;
      quoteDetails(this.form).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.quoteDetails.map((item) => {

            return item; //表格数据
          });
          this.typedata = res.data.type
          this.xData = res.data.quotePriceInfos; //这个是总价echats数据
          this.supplierInfo = res.data.supplierInfo; //报价信息数据
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
        this.TotalPrice();
      });
    },
    open() {
      this.$nextTick(() => {
        this.PriceComparison();
      });
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //柱状图
    TotalPrice() {
      var myChart = echarts.init(document.getElementById("TotalPrice"));
      myChart.setOption({
        xAxis: {
          triggerEvent: true, //1.设置x轴文字宽度过长显示...
          type: "category",
          name: "企业",
          data: this.xData.map((item) => item.name),
          axisLabel: {
            textStyle: {
              color: "gray", //更改坐标轴文字颜色
            },
            formatter(v) {
              //2.设置x轴文字宽度过长显示...
              let res = v;
              if (res.length > 7) {
                res = res.substring(0, 7) + "...";
              }
              return res;
            },
          },
          axisTick: {
            show: false,
          },
        },
        tooltip: {
          show: true,
          trigger: "axis",
          transitionDuration: 0, //echart防止tooltip的抖动
        },
        yAxis: {
          name: "总价",
          type: "value",
          axisTick: {
            show: false,
          },

          splitLine: {
            show: true,
          },
        },
        color: "#5a74e3",
        grid: {
          height: 200,
        },
        series: [
          {
            data: this.xData.map((item) => item.price),
            type: "bar",
            barWidth: 50, //柱图宽度
          },
        ],
      });
      $("#myChart canvas").width(1000); //改变canvas的宽度
    },
    //比价按钮
    handleQuotedPrice(item, index) {
      purchaseOrderDetailsId({
        purchaseOrderDetailsId: item.purchaseOrderDetailsId,
      }).then((res) => {
        this.PriceData = res.data; //比价echats数据
        this.editVisible = true;
      });
    },
    //比价折线图
    PriceComparison() {
      var myChart = echarts.init(document.querySelector("#priceComparison"));

      myChart.setOption({
        xAxis: {
          type: "category",
          name: "企业",


          data: this.PriceData.map((item) => item.name),

        },
        axisLabel: {
          // interval: 2,
          textStyle: {
            color: "gray", //更改坐标轴文字颜色
          },
          formatter(v) {
            //2.设置x轴文字宽度过长显示...
            let res = v;
            if (res.length > 7) {
              res = res.substring(0, 7) + "...";
            }
            return res;
          },
        },
        tooltip: {
          show: true,
          trigger: "axis",
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
          },
        },
        grid: {
          height: 180,
        },
        series: [
          {
            data: this.PriceData.map((item) => item.price),
            type: "bar",
            // smooth: true, //平滑线
            symbol: "none", //去掉圆点
            barWidth: 50, //柱图宽度
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    //中标
    handleWinning() {
      // console.log(11);
      // console.log(this.isSelected, "issele");
      if (this.accountStatus == 1) {
        if (this.isSelected == "null") {
          //没有报价过
          winning({
            purchaseOrderId: this.purchaseOrderId,
            supplierId: this.form.supplierId,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "中标成功",
              });
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
            this.$nextTick(() => {
              this.$router.push("/mypurchase");
            });
          });
        } else {
          this.$message({
            type: "error",
            message: "该账户已经中标",
          });
        }
      } else {
        this.$message({type: "info", message: "该账户已被禁用"});
      }
    },
  },
};
</script>
<style lang="less" scoped>
.PriceComparison {
  width: 100%;
  height: 300px;
}

.TotalPrice {
  width: 1200px;
  height: 300px;
}

.buyid {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  margin-left: 30px;

  span {
    color: gray;
  }
}

.main {
  background-color: white;
  padding: 20px;

  .navs_top {
    display: flex;
    justify-content: space-between;

    .nav_right {
      display: flex;
      justify-content: space-between;

      .time {
        margin-top: 10px;
      }
    }
  }

  .nav_step {
    width: 65%;

    margin: 30px 0;
  }

  .nav_top {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
  }

  .nav_content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .renzhen {
      margin-right: 40px;
      border: 1px solid #c65442;
      background-color: rgb(241, 212, 212);
      color: #c65442;
      width: 50px;
      font-size: 12px;
      height: 20px;
      text-align: center;
      line-height: 20px;
    }

    span {
      font-weight: normal;
      color: gray;
    }
  }
}

.nav_right {
  .startbtn {
    color: white;
    width: 100px;
    height: 40px;
    line-height: 20px;
    background-color: #c65442;
    padding: 10px;
  }
}

.main_top {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 2.5px dotted #e3e3e3;
}

.main_content {
  margin-top: 30px;
  padding-bottom: 50px;

  .pricebtn {
    border: 1px solid #c65442;
    color: #c65442;
  }
}

.main-flag {
  margin-bottom: 20px;
  // margin-left: 20px;
  b {
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #c6523f;
    vertical-align: middle;
  }

  span {
    font-weight: bold;
    font-size: 18px;
    padding-left: 8px;
    vertical-align: middle;
  }
}

.bjinfo {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 14px;

  p {
    width: 33%;
    height: 40px;
    line-height: 40px;

    span {
      color: gray;
    }
  }
}

.bjnum {
  display: flex;
  width: 80%;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 14px;

  div {
    padding: 10px;
    background-color: #eee;

    span {
      padding: 0 5px;
      color: #c6523f;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.zhongb {
  padding: 30px 0;
  margin: auto 0;
  display: flex;
  justify-content: center;
}

.zbtn {
  color: white;
  width: 150px;
  background-color: #c65442;
}

.price {
  border: 1px solid #c65442;
  background-color: rgb(241, 212, 212);
  color: #c65442;
}
</style>



// WEBPACK FOOTER //
// src/views/procurementTenders/quoteNow.vue